import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTenantSettings extends Layout {
	dataHeaderMain: DataHeader;
	sourceCurrentTenant: DataSource;
	textboxCompanyName: Textbox;
	textboxHomeUrl: Textbox;
}
